angular.module('am4').factory('maintenanceModeInterceptor', function($window, $location, $injector, config) {
    return {
        response: function(response) {
            var port,
                protocol;
            // If our api responds with a maintenance mode header, we bail to the maintenance page
            if (
                response.headers('X-Maintenance-Mode') &&
                response.config.url.indexOf(config.apiUrl) === 0 &&
                // Exclude translations endpoint to avoid loop
                !response.config.url.includes('/translations')
            ) {
                // So we don't double-reload when we hit the maintenance route
                // We can't depend on UserService directly here because it would be a circular dependency
                $injector.get('UserService').clearToken();

                protocol = $location.protocol();
                port = $location.port();
                port = !(protocol === 'https' && port === 443) && !(protocol === 'http' && port === 80) ? ':' + port : '';

                // Reload the page in maintenance mode
                // This is a 'hard reload', mainly to clear any page state about the logged in user
                $window.location.href = $location.protocol() + '://' + $location.host() + port + '/maintenance';
                return;
            }

            return response;
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/services/maintenanceModeInterceptor.js